const title = "尺度の大きさランキング（全体）";
const rank = [
  "1位",
  "2位",
  "3位",
  "4位",
  "5位",
  "6位",
  "7位",
  "8位",
  "9位",
  "10位",
  "11位",
  "12位",
  "13位"
];
const MeasureSize = (data, xCategories) => ({
  chart: {
    type: "bar"
  },
  title: {
    text: title
  },
  colors: ["#f44336"],
  xAxis: {
    categories: xCategories,
    crosshair: true,
    labels: {
      align: "right",
      useHTML: true,
      formatter() {
        return ` <span style="display: inline-block;width: 150px;">${
          rank[this.pos]
        } ${this.value}</span> `;
      }
    }
  },
  yAxis: {
    min: 0,
    max: 100,
    title: null,
    tickInterval: 20
  },
  tooltip: {
    enabled: false
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: `{point.y:.1f}`
      }
    },
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    }
  },
  series: [
    {
      name: null,
      data
    }
  ],
  color: ["#f45b5b"],
  legend: {
    enabled: false
  },
  credits: {
    enabled: false
  }
});

export default MeasureSize;



// WEBPACK FOOTER //
// ./src/models/MeasureSize.js